import React, { FC, Fragment } from 'react';
import { Container } from '../../components/base/grid';
import Breadcrumbs from '../../components/breadcrumbs';
import CustomerOpinionsForm from '../../components/customerOpinions';
import SplitHero from '../../components/hero/splitHero';
import pageWrapper from '../../hoc/pageWrapper';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';
import { ContentSectionsMapper } from '../contentSite/contentSectionsMapper';

interface Props {
	page: IPageViewModel;
}

const CustomerOpinions: FC<Props> = ({ page }) => {
	return (
		<Container>
			<Breadcrumbs pageId={page.Id} />

			{page.Values.HeroImage && page.Values.HeroContent.length > 0 && (
				<SplitHero
					pageId={page.Id}
					title={page.Values.HeroTitle || page.Name}
					content={page.Values.HeroContent}
					button={page.Values.HeroButton}
					image={page.Values.HeroImage}
				/>
			)}

			{page.Values.ContentSections &&
				page.Values.ContentSections.length > 0 &&
				page.Values.ContentSections.map((item, index) => (
					<Fragment key={index}>{ContentSectionsMapper(item)}</Fragment>
				))}

			<CustomerOpinionsForm />
		</Container>
	);
};

export default pageWrapper(CustomerOpinions);
